export default [
    {
        path: '/dynamic-joins',
        name: 'dynamic-joins',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Junção',
            icon: 'mdi-merge',
            breadcrumbs: [
                { text: 'Junção dinâmica', disabled: true, href: '/' },
                { text: 'Junção', disabled: true, href: '/' },
            ],
        }
    },
]